import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function ChevronRightIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 27 25" htmlColor={Color.Body} {...props}>
      <path d="M14.25 12.725 9.91 8.652a.7.7 0 0 1-.227-.522.69.69 0 0 1 .227-.532.8.8 0 0 1 .562-.217.8.8 0 0 1 .561.217l4.791 4.494q.15.141.211.297a.9.9 0 0 1 .062.336q0 .18-.062.337a.8.8 0 0 1-.211.296l-4.79 4.494a.8.8 0 0 1-.557.213.78.78 0 0 1-.567-.213.7.7 0 0 1-.232-.527q0-.31.232-.527l4.342-4.073Z" />
    </MuiSvgIcon>
  );
}
export default ChevronRightIcon;
